<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="ch00_fm05_dedication"></a><a id="page_v"></a><em>To Becky,</em></p>
<p class="dedi2"><em>in celebration of our 40 years!</em></p>
<p class="dedi1"><img alt="image" src="images/com.jpg"/></p>
<p class="dedi2"><em>And to Helen Keller,</em></p>
<p class="dedi2"><em>whom I grew to enjoy</em></p>
<p class="dedi2"><em>far more than I ever imagined I would.</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_dedication.vue?7551e1ac